/* Accu Clips configurator */
(function () {
  function init(root) {
    if (root.dataset.acxReady === '1') return;
    root.dataset.acxReady = '1';

    var cfgEl = root.querySelector('[data-acx-config]');
    if (!cfgEl) return;
    var CFG = JSON.parse(cfgEl.textContent);

    var MAXCHARS = CFG.maxTekens || 4;
    var MINS = String(CFG.staffel || '1').split(',').map(function (s) { return parseInt(s, 10) || 1; });
    var KORT = String(CFG.kortingen || '0').split(',').map(function (s) { return parseFloat(s) || 0; });
    var MIN = MINS[0] || 1;
    var MINKLEUR = parseInt(CFG.minKleurcombo, 10) || 1;
    var LOGOPRIJS = parseFloat(CFG.logoPrijs) || 0;
    var VOORLABEL = CFG.voorLabel || 'Voor welke accu?';

    /* Op één plek, zodat een adreswijziging niet door het hele bestand hoeft. */
    var MAILADRES = 'info@3dprintbyd.com';

    /* Toegestane logobestanden. Cloudinary zet alles om naar een bruikbaar
       bestand; wat de klant aanlevert wordt door ons printklaar gemaakt. */
    var LOGOFORMATEN = ['png', 'svg', 'jpg', 'jpeg', 'webp', 'heic', 'heif', 'pdf'];
    var LOGOMAXMB = 20;

    var matBtns = Array.prototype.slice.call(root.querySelectorAll('[data-acx-mat]'));
    var accuBtns = Array.prototype.slice.call(root.querySelectorAll('[data-acx-accu]'));
    var rowsEl = root.querySelector('[data-acx-rows]');
    var chipsEl = root.querySelector('[data-acx-chips]');
    var tiersEl = root.querySelector('[data-acx-tiers]');
    var sumEl = root.querySelector('[data-acx-sum]');
    var emptyEl = root.querySelector('[data-acx-empty]');
    var totalEl = root.querySelector('[data-acx-total]');
    var detailEl = root.querySelector('[data-acx-detail]');
    var saveEl = root.querySelector('[data-acx-save]');
    var vanafEl = root.querySelector('[data-acx-vanaf]');
    var errEl = root.querySelector('[data-acx-error]');
    var cta = root.querySelector('[data-acx-cta]');
    var notifyEl = root.querySelector('[data-acx-notify]');
    var notifySel = root.querySelector('[data-acx-notify-select]');

    /* De samenvattingsrij boven de regels is dubbelop met het controleoverzicht
       in de laatste stap en toont bij een lege regel alleen ruis. Weggehaald. */
    if (chipsEl) chipsEl.style.display = 'none';

    /* brands is een lijst: iemand kan accu's van meerdere merken hebben. */
    var state = { brands: [], accus: [], material: '', matLabel: '', rows: [], id: 0 };

    function money(v) { return '\u20ac' + v.toFixed(2).replace('.', ','); }
    function meerMerken() { return state.brands.length > 1; }

    function bestandsExtensie(naam) {
      var n = String(naam || '').toLowerCase();
      return n.indexOf('.') === -1 ? '' : n.split('.').pop();
    }

    /* Een PDF of HEIC kan een browser niet in een img-tag tonen. Cloudinary
       kan er wel een PNG van maken, dus voor de voorbeeldweergave vragen we
       een omgezette versie op. Het originele bestand gaat naar de bestelling. */
    function logoPreviewUrl(res) {
      if (!res) return '';
      if (res.public_id && CFG.cloudName) {
        return 'https://res.cloudinary.com/' + CFG.cloudName +
               '/image/upload/f_png,pg_1,w_600,c_limit/' + res.public_id + '.png';
      }
      return res.secure_url || '';
    }

    /* Cloudinary geeft met etag een hash van de bestandsinhoud terug. Twee keer
       hetzelfde logo uploaden levert dezelfde hash, ook bij een andere naam.
       Zo rekenen we opmaakkosten per uniek logo in plaats van per regel. */
    function logoSleutels() {
      var lijst = [];
      state.rows.forEach(function (r) {
        if (r.mode !== 'logo' || !r.logoUrl) return;
        var s = r.logoHash || r.logoUrl;
        if (lijst.indexOf(s) === -1) lijst.push(s);
      });
      return lijst;
    }

    /* Groepeert alle regels op kleurcombinatie (clip + tekst) en telt het
       aantal clips per combinatie op. Elke kleurwissel kost printtijd, dus
       een order met veel verschillende combinaties in kleine aantallen is
       voor ons duurder dan de staffelprijs doet vermoeden. */
    function kleurCombos() {
      var combos = {};
      state.rows.forEach(function (r) {
        var key = r.clip + '|' + r.letter;
        combos[key] = (combos[key] || 0) + (r.qty || 0);
      });
      return combos;
    }

    function helderheid(hex) {
      var h = String(hex || '').replace('#', '');
      if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
      if (h.length !== 6) return 1;
      return 0.2126 * (parseInt(h.slice(0, 2), 16) / 255) +
             0.7152 * (parseInt(h.slice(2, 4), 16) / 255) +
             0.0722 * (parseInt(h.slice(4, 6), 16) / 255);
    }
    function randkleur(hex) {
      return helderheid(hex) > 0.55 ? 'rgba(0,0,0,.55)' : 'rgba(255,255,255,.75)';
    }

    function parseColors(raw) {
      return String(raw || '').split('\n').map(function (l) {
        var p = l.split(':');
        if (p.length < 2) return null;
        return { naam: p[0].trim(), hex: p[1].trim() };
      }).filter(Boolean);
    }

    function materialData(name) {
      var btn = matBtns.filter(function (b) { return b.dataset.acxMat === name; })[0];
      return btn ? { colors: parseColors(btn.dataset.acxMatKleuren), label: btn.dataset.acxMatLabel || name }
                 : { colors: [], label: name };
    }

    function tiersFor(mat) {
      var v = CFG.variants.filter(function (x) { return x.opt1 === mat; })[0];
      if (!v) return [];
      return MINS.map(function (m, i) {
        return { min: m, id: v.id, price: Math.max(v.price - (KORT[i] || 0), 0) };
      }).sort(function (a, b) { return a.min - b.min; });
    }

    function tierFor(mat, n) {
      var t = tiersFor(mat);
      var hit = t[0];
      for (var i = 0; i < t.length; i++) { if (n >= t[i].min) hit = t[i]; }
      return hit;
    }

    function totaalClips() {
      return state.rows.reduce(function (s, r) { return s + r.qty; }, 0);
    }

    function volgendeTrap() {
      var tiers = tiersFor(state.material);
      var total = totaalClips();
      for (var i = 1; i < tiers.length; i++) {
        if (total < tiers[i].min) return { nodig: tiers[i].min - total, prijs: tiers[i].price };
      }
      return null;
    }

    function laagstePrijs() {
      var laagste = null;
      CFG.variants.forEach(function (v) {
        tiersFor(v.opt1).forEach(function (x) { if (laagste === null || x.price < laagste) laagste = x.price; });
      });
      return laagste;
    }

    if (vanafEl) {
      var lp = laagstePrijs();
      vanafEl.innerHTML = lp === null ? '' : 'Vanaf ' + money(lp) + '<small>per clip</small>';
    }

    /* ---- merken, meerdere tegelijk ---- */
    var brandBtns = Array.prototype.slice.call(root.querySelectorAll('[data-acx-brand]'));

    /* Titel en hulptekst van deze stap worden nu native door de sectie
       gerenderd via section.settings.merk_titel / merk_hint, dus hier is
       geen tekstpatch meer nodig (voorheen stond hier een override). */

    brandBtns.forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') {
        var start = b.dataset.acxBrand;
        if (state.brands.indexOf(start) === -1) state.brands.push(start);
      }
      b.addEventListener('click', function () {
        var merk = b.dataset.acxBrand;
        var pos = state.brands.indexOf(merk);
        if (pos === -1) {
          state.brands.push(merk);
          b.setAttribute('aria-pressed', 'true');
        } else {
          state.brands.splice(pos, 1);
          b.setAttribute('aria-pressed', 'false');
          /* accu's van dit merk laten vallen, inclusief de regels die eraan hingen */
          var weg = state.accus.filter(function (a) { return a.merk === merk; }).map(accuSleutel);
          state.accus = state.accus.filter(function (a) { return a.merk !== merk; });
          state.rows.forEach(function (r) { if (weg.indexOf(r.accu) !== -1) r.accu = ''; });
          accuBtns.forEach(function (a) {
            if (a.dataset.acxAccuMerk === merk && a.dataset.acxAccuBinnenkort !== 'true') {
              a.setAttribute('aria-pressed', 'false');
            }
          });
        }
        if (state.accus.length === 1) {
          state.rows.forEach(function (r) { r.accu = accuSleutel(state.accus[0]); });
        }
        toonAccus(); updateAccuLabels(); herbouwAccuKeuzes(); render();
      });
    });

    function toonAccus() {
      accuBtns.forEach(function (a) {
        a.hidden = state.brands.indexOf(a.dataset.acxAccuMerk) === -1;
      });
    }

    /* Bij meer dan één merk staat de merknaam voor de serie, anders zou
       "5.0 Ah" van Makita en DeWalt niet uit elkaar te houden zijn. */
    function updateAccuLabels() {
      var toonMerk = meerMerken();
      accuBtns.forEach(function (btn) {
        var el = btn.querySelector('.acx__vnaam');
        if (!el) return;
        var em = el.querySelector('em');
        el.textContent = (toonMerk ? btn.dataset.acxAccuMerk + ' \u00b7 ' : '') +
                         btn.dataset.acxAccuSerie + ' \u00b7 ' + btn.dataset.acxAccu;
        if (em) { el.appendChild(document.createTextNode(' ')); el.appendChild(em); }
      });
    }

    toonAccus();
    updateAccuLabels();

    /* ---- accuvarianten, meerdere tegelijk ---- */
    function accuSleutel(a) { return a.merk + ' ' + a.serie + ' ' + a.naam; }

    function accuLabel(a) {
      return (meerMerken() ? a.merk + ' \u00b7 ' : '') + a.serie + ' \u00b7 ' + a.naam;
    }

    accuBtns.forEach(function (btn) {
      if (btn.dataset.acxAccuBinnenkort === 'true') {
        /* nog niet leverbaar: wachtlijst openen met deze accu voorgeselecteerd */
        btn.addEventListener('click', function () {
          if (!notifyEl) return;
          notifyEl.open = true;
          if (notifySel) {
            var wens = btn.dataset.acxAccuMerk + ' ' + btn.dataset.acxAccuSerie + ' ' + btn.dataset.acxAccu;
            Array.prototype.slice.call(notifySel.options).forEach(function (o) {
              if (o.value === wens) notifySel.value = o.value;
            });
          }
          notifyEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        return;
      }
      btn.addEventListener('click', function () {
        var aan = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', aan ? 'false' : 'true');
        var item = {
          merk: btn.dataset.acxAccuMerk,
          naam: btn.dataset.acxAccu,
          serie: btn.dataset.acxAccuSerie,
          types: btn.dataset.acxAccuTypes || '',
          model: btn.dataset.acxAccuModel || ''
        };
        var sleutel = accuSleutel(item);
        if (aan) {
          state.accus = state.accus.filter(function (a) { return accuSleutel(a) !== sleutel; });
          state.rows.forEach(function (r) { if (r.accu === sleutel) r.accu = ''; });
        } else {
          state.accus.push(item);
        }
        if (state.accus.length === 1) {
          state.rows.forEach(function (r) { r.accu = accuSleutel(state.accus[0]); });
        }
        herbouwAccuKeuzes();
        render();
      });
    });

    /* ---- uitvoering ---- */
    matBtns.forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') {
        state.material = b.dataset.acxMat;
        state.matLabel = b.dataset.acxMatLabel || b.dataset.acxMat;
      }
      b.addEventListener('click', function () {
        matBtns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        state.material = b.dataset.acxMat;
        state.matLabel = b.dataset.acxMatLabel || b.dataset.acxMat;
        remapColors();
        render();
      });
    });
    if (!state.material && matBtns.length) {
      state.material = matBtns[0].dataset.acxMat;
      state.matLabel = matBtns[0].dataset.acxMatLabel || state.material;
      matBtns[0].setAttribute('aria-pressed', 'true');
    }

    matBtns.forEach(function (b) {
      var t = tiersFor(b.dataset.acxMat);
      var lab = b.querySelector('[data-acx-mat-vanaf]');
      if (lab && t.length) {
        var lowest = t.reduce(function (m, x) { return x.price < m ? x.price : m; }, t[0].price);
        lab.textContent = 'Vanaf ' + money(lowest) + ' per clip';
      }
    });

    function remapColors() {
      var cols = materialData(state.material).colors;
      var names = cols.map(function (c) { return c.naam; });
      state.rows.forEach(function (r) {
        rebuildSwatches(r);
        if (names.indexOf(r.clip) === -1) {
          var d = cols[0] || { naam: '', hex: '#232629' };
          r.clip = d.naam; r.clipHex = d.hex;
        }
        if (names.indexOf(r.letter) === -1) {
          var d2 = cols[1] || cols[0] || { naam: '', hex: '#f5f5f2' };
          r.letter = d2.naam; r.letterHex = d2.hex;
        }
        syncSwatches(r);
        if (r.repaint) r.repaint();
      });
    }

    function rebuildSwatches(r) {
      var cols = materialData(state.material).colors;
      [['sw1', 'clip'], ['sw2', 'letter']].forEach(function (pair) {
        var box = r.el.querySelector('.' + pair[0]);
        box.innerHTML = '';
        cols.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.style.background = c.hex;
          b.setAttribute('aria-label', c.naam);
          b.title = c.naam;
          b.addEventListener('click', function () {
            box.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
            b.setAttribute('aria-pressed', 'true');
            if (pair[1] === 'clip') { r.clip = c.naam; r.clipHex = c.hex; }
            else { r.letter = c.naam; r.letterHex = c.hex; }
            if (r.repaint) r.repaint();
          });
          box.appendChild(b);
        });
      });
    }

    function syncSwatches(r) {
      r.el.querySelectorAll('.sw1 button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('aria-label') === r.clip ? 'true' : 'false');
      });
      r.el.querySelectorAll('.sw2 button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('aria-label') === r.letter ? 'true' : 'false');
      });
    }

    /* per regel: bij welke accu hoort deze? alleen bij meer dan één gekozen accu */
    function herbouwAccuKeuzes() {
      state.rows.forEach(function (r) {
        var vak = r.el.querySelector('.acx__voor');
        var titel = vak.querySelector('span');
        var knoppen = r.el.querySelector('.acx__voorknoppen');
        titel.textContent = VOORLABEL;
        knoppen.innerHTML = '';
        if (state.accus.length < 2) {
          vak.hidden = true;
          if (state.accus.length === 1) r.accu = accuSleutel(state.accus[0]);
          return;
        }
        vak.hidden = false;
        state.accus.forEach(function (a) {
          var sleutel = accuSleutel(a);
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = accuLabel(a);
          b.setAttribute('aria-pressed', r.accu === sleutel ? 'true' : 'false');
          b.addEventListener('click', function () {
            r.accu = sleutel;
            herbouwAccuKeuzes();
            render();
          });
          knoppen.appendChild(b);
        });
      });
    }

    /* ---- regels ---- */
    function addRow() {
      state.id++;
      /* Elke regel start op MINKLEUR, niet op 1. Zo kan een klant nooit
         per ongeluk vijf regels van elk 1 stuk maken — precies het patroon
         dat vijf kleurwissels kost voor één staffelkorting. */
      var startQty = MINKLEUR;
      var cols = materialData(state.material).colors;
      var d1 = cols[0] || { naam: 'Zwart', hex: '#232629' };
      var d2 = cols[1] || d1;
      var r = { id: state.id, accu: state.accus.length === 1 ? accuSleutel(state.accus[0]) : '',
                mode: 'initialen', text: '', logoUrl: '', logoPreview: '', logoName: '', logoHash: '', rights: false,
                clip: d1.naam, clipHex: d1.hex, letter: d2.naam, letterHex: d2.hex,
                qty: startQty, el: null, repaint: null };
      state.rows.push(r);

      var el = document.createElement('div');
      el.className = 'acx__row';
      r.el = el;
      el.innerHTML =
        '<div class="acx__rowtop"><span class="acx__rowlab"></span>' +
        '<button type="button" class="acx__del">verwijderen</button></div>' +
        '<div class="acx__voor" hidden><span></span><div class="acx__voorknoppen"></div></div>' +
        '<div class="acx__modes">' +
          '<button type="button" data-mode="initialen" aria-pressed="true">Initialen</button>' +
          '<button type="button" data-mode="logo" aria-pressed="false">Logo</button>' +
        '</div>' +
        '<div class="acx__f f-text"><label>Initialen of nummer (max. ' + MAXCHARS + ' tekens)</label>' +
          '<input type="text" maxlength="' + MAXCHARS + '" placeholder="JVD" autocomplete="off" autocapitalize="characters">' +
          '<div class="acx__meta"><span>Letters en cijfers, bijvoorbeeld JVD of BUS1</span><span class="c">0/' + MAXCHARS + '</span></div></div>' +
        '<div class="acx__f f-logo" hidden><label>Upload je logo</label>' +
          '<input type="file" accept="image/*,application/pdf,.png,.svg,.jpg,.jpeg,.webp,.heic,.heif,.pdf">' +
          '<div class="acx__meta"><span class="st">PNG, SVG, JPG, WEBP, HEIC of PDF \u00b7 tot ' + LOGOMAXMB + ' MB</span></div>' +
          '<label class="acx__rights"><input type="checkbox"> Ik heb het recht dit logo te laten printen.</label>' +
          '<p class="acx__muted">Een vectorbestand (SVG of PDF) geeft het scherpste resultaat, maar een foto of JPG mag ook \u2014 wij maken hem printklaar. Dat kost eenmalig ' + money(LOGOPRIJS) + ' per logo. Gebruik je hetzelfde logo op meerdere accutypen, dan betaal je dat maar \u00e9\u00e9n keer.</p></div>' +
        '<div class="acx__f"><label>Clipkleur</label><div class="acx__sw sw1"></div></div>' +
        '<div class="acx__f"><label>Kleur initialen of logo</label><div class="acx__sw sw2"></div>' +
          '<button type="button" class="acx__copy">Deze kleuren voor alle regels gebruiken</button>' +
          '<p class="acx__warn" hidden>Clip en tekst hebben dezelfde kleur. De letters komen verhoogd uit de clip, dus in het echt blijven ze goed leesbaar.</p>' +
          '<p class="acx__kleurhint" hidden></p></div>' +
        '<div class="acx__chip"><div class="acx__clip">JVD</div><small>voorbeeldweergave</small></div>' +
        '<div class="acx__f"><label>Aantal clips (minimaal ' + MINKLEUR + ')</label><div class="acx__qty">' +
          '<button type="button" class="m" aria-label="E\u00e9n minder">\u2212</button>' +
          '<input type="number" min="' + MINKLEUR + '" step="1" inputmode="numeric" aria-label="Aantal clips" value="' + MINKLEUR + '">' +
          '<button type="button" class="p" aria-label="E\u00e9n meer">+</button></div>' +
          '<p class="acx__rowhint"></p></div>';
      rowsEl.appendChild(el);

      rebuildSwatches(r);
      syncSwatches(r);

      el.querySelector('.acx__copy').addEventListener('click', function () {
        state.rows.forEach(function (o) {
          if (o.id === r.id) return;
          o.clip = r.clip; o.clipHex = r.clipHex;
          o.letter = r.letter; o.letterHex = r.letterHex;
          syncSwatches(o);
          if (o.repaint) o.repaint();
        });
        render();
      });

      var textIn = el.querySelector('.f-text input');
      var counter = el.querySelector('.c');
      textIn.addEventListener('input', function () {
        var clean = textIn.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, MAXCHARS);
        textIn.value = clean;
        r.text = clean;
        counter.textContent = clean.length + '/' + MAXCHARS;
        paint();
      });

      var fileIn = el.querySelector('.f-logo input[type=file]');
      var st = el.querySelector('.st');
      fileIn.addEventListener('change', function () {
        var f = fileIn.files && fileIn.files[0];
        if (!f) return;

        if (LOGOFORMATEN.indexOf(bestandsExtensie(f.name)) === -1) {
          fileIn.value = '';
          r.logoUrl = ''; r.logoPreview = ''; r.logoName = ''; r.logoHash = '';
          st.textContent = 'Dit bestandstype kunnen we niet gebruiken. Upload een PNG, SVG, JPG, WEBP, HEIC of PDF, of mail je logo naar ' + MAILADRES + '.';
          render();
          return;
        }
        if (f.size > LOGOMAXMB * 1024 * 1024) {
          fileIn.value = '';
          r.logoUrl = ''; r.logoPreview = ''; r.logoName = ''; r.logoHash = '';
          st.textContent = 'Dit bestand is groter dan ' + LOGOMAXMB + ' MB. Mail het naar ' + MAILADRES + ', dan regelen we het.';
          render();
          return;
        }

        r.logoName = f.name; r.logoUrl = ''; r.logoPreview = ''; r.logoHash = '';
        st.textContent = 'Uploaden\u2026 0%';
        var fd = new FormData();
        fd.append('file', f);
        fd.append('upload_preset', CFG.uploadPreset);
        fd.append('folder', 'shopify-orders');
        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + CFG.cloudName + '/auto/upload');
        xhr.upload.onprogress = function (e) {
          if (e.lengthComputable) st.textContent = 'Uploaden\u2026 ' + Math.round((e.loaded / e.total) * 100) + '%';
        };
        xhr.onload = function () {
          var res = null;
          try { res = JSON.parse(xhr.responseText); } catch (err) {}
          if (xhr.status >= 200 && xhr.status < 300 && res && res.secure_url) {
            r.logoUrl = res.secure_url;
            r.logoPreview = logoPreviewUrl(res);
            r.logoHash = res.etag || res.public_id || res.secure_url;
            st.textContent = 'Logo ontvangen: ' + r.logoName;
          } else {
            var melding = res && res.error && res.error.message ? res.error.message : '';
            st.textContent = 'Uploaden mislukt. ' + (melding ? '(' + melding + ') ' : '') +
              'Probeer het opnieuw of mail je logo naar ' + MAILADRES + '.';
          }
          paint();
        };
        xhr.onerror = function () {
          st.textContent = 'Uploaden mislukt. Probeer het opnieuw of mail je logo naar ' + MAILADRES + '.';
          paint();
        };
        xhr.send(fd);
        paint();
      });

      el.querySelector('.acx__rights input').addEventListener('change', function (e) {
        r.rights = e.target.checked; render();
      });

      el.querySelectorAll('.acx__modes button').forEach(function (mb) {
        mb.addEventListener('click', function () {
          el.querySelectorAll('.acx__modes button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          mb.setAttribute('aria-pressed', 'true');
          r.mode = mb.dataset.mode;
          el.querySelector('.f-text').hidden = r.mode !== 'initialen';
          el.querySelector('.f-logo').hidden = r.mode !== 'logo';
          paint();
        });
      });

      var qtyIn = el.querySelector('.acx__qty input');
      qtyIn.value = r.qty;
      qtyIn.addEventListener('input', function () {
        var schoon = qtyIn.value.replace(/[^0-9]/g, '');
        qtyIn.value = schoon;
        var n = parseInt(schoon, 10);
        r.qty = isNaN(n) ? 0 : n;
        render();
      });
      qtyIn.addEventListener('blur', function () {
        if (!r.qty || r.qty < MINKLEUR) { r.qty = MINKLEUR; }
        qtyIn.value = r.qty;
        render();
      });

      el.querySelector('.m').addEventListener('click', function () { if (r.qty > MINKLEUR) { r.qty--; paint(); } });
      el.querySelector('.p').addEventListener('click', function () { r.qty++; paint(); });
      el.querySelector('.acx__del').addEventListener('click', function () {
        state.rows = state.rows.filter(function (x) { return x.id !== r.id; });
        el.remove(); renumber(); render();
      });

      function paint() {
        var chip = el.querySelector('.acx__clip');
        chip.style.background = r.clipHex;
        chip.style.color = r.letterHex;
        if (r.mode === 'logo' && r.logoUrl) {
          chip.style.textShadow = 'none';
          chip.innerHTML = '';
          var im = document.createElement('img');
          im.src = r.logoPreview || r.logoUrl;
          im.alt = 'Voorbeeld van je logo';
          /* Lukt de omzetting niet, dan tonen we geen kapotte afbeelding.
             Het bestand is wel gewoon ontvangen. */
          im.onerror = function () { chip.innerHTML = ''; chip.textContent = 'LOGO'; };
          chip.appendChild(im);
        } else {
          chip.textContent = r.mode === 'logo' ? '?' : (r.text || 'JVD');
          var rand = randkleur(r.letterHex);
          chip.style.textShadow =
            '-1px 0 0 ' + rand + ', 1px 0 0 ' + rand + ', 0 -1px 0 ' + rand + ', 0 1px 0 ' + rand +
            ', 0 2px 2px rgba(0,0,0,.28)';
        }
        qtyIn.value = r.qty;
        el.querySelector('.acx__warn').hidden = !(r.clipHex && String(r.clipHex).toLowerCase() === String(r.letterHex).toLowerCase());
        render();
      }
      r.repaint = paint;
      renumber();
      herbouwAccuKeuzes();
      paint();
    }

    function renumber() {
      rowsEl.querySelectorAll('.acx__row').forEach(function (el, i) {
        el.querySelector('.acx__rowlab').textContent = 'Naam ' + (i + 1);
      });
    }

    root.querySelector('[data-acx-add]').addEventListener('click', addRow);
    addRow();

    /* ---- prijs en overzicht ---- */
    function render() {
      var total = totaalClips();
      var tiers = tiersFor(state.material);
      var tier = tierFor(state.material, Math.max(total, MIN));
      var base = tiers.length ? tiers[0].price : 0;
      var logoAantal = logoSleutels().length;
      var logoKosten = logoAantal * LOGOPRIJS;
      var nxt = volgendeTrap();
      var combos = kleurCombos();

      tiersEl.innerHTML = '';
      tiers.forEach(function (t, i) {
        var upper = tiers[i + 1] ? tiers[i + 1].min - 1 : null;
        var label = upper ? t.min + '\u2013' + upper : t.min + '+';
        var s = document.createElement('span');
        s.className = 'acx__trap' + (t === tier && total >= MIN ? ' is-hit' : '');
        s.innerHTML = label + ' clips <b>' + money(t.price) + '</b>';
        tiersEl.appendChild(s);
      });

      var hintTekst = (total >= MIN && nxt)
        ? 'Nog ' + nxt.nodig + ' clips en de stukprijs daalt naar ' + money(nxt.prijs) : '';
      rowsEl.querySelectorAll('.acx__rowhint').forEach(function (h) { h.textContent = hintTekst; });

      var clipKosten = total * (tier ? tier.price : 0);
      totalEl.textContent = money(clipKosten + logoKosten);

      /* Bij één regel volstaat het aantal clips; bij meer regels helpt het
         aantal regels als kort ooriëntatiepunt in de vaste onderbalk. */
      var regelPrefix = state.rows.length > 1 ? (state.rows.length + ' regels \u00b7 ') : '';
      detailEl.textContent = regelPrefix + total + (total === 1 ? ' clip \u00d7 ' : ' clips \u00d7 ') + money(tier ? tier.price : 0) +
        (logoAantal ? ' + ' + money(logoKosten) + ' logo-opmaak' +
          (logoAantal > 1 ? ' (' + logoAantal + ' logo\u2019s)' : '') : '');

      var saved = (base - (tier ? tier.price : 0)) * total;
      if (saved > 0.005) {
        saveEl.hidden = false;
        saveEl.textContent = 'Je bespaart ' + money(saved) + ' \u2014 korting wordt verrekend bij het afrekenen';
      } else { saveEl.hidden = true; }

      sumEl.innerHTML = '';
      state.rows.forEach(function (r) {
        var accu = state.accus.filter(function (a) { return accuSleutel(a) === r.accu; })[0];
        var wat = r.mode === 'initialen' ? (r.text || '\u2014') : ('Logo ' + (r.logoName || '\u2014'));
        var regels = [];
        if (accu) regels.push(accu.merk + ' \u00b7 ' + accu.serie + ' \u00b7 ' + accu.naam);
        regels.push(state.matLabel + ' \u00b7 clip ' + String(r.clip).toLowerCase() + ' \u00b7 tekst ' + String(r.letter).toLowerCase());
        sumEl.insertAdjacentHTML('beforeend',
          '<tr><td><strong>' + wat + '<\/strong><br><span class="acx__muted">' + regels.join('<br>') +
          '<\/span><\/td><td>' + r.qty + ' \u00d7 ' + money(tier ? tier.price : 0) +
          '<br><span class="acx__muted">' + money(r.qty * (tier ? tier.price : 0)) + '<\/span><\/td><\/tr>');

        var comboKey = r.clip + '|' + r.letter;
        var comboTotaal = combos[comboKey] || 0;
        var hintEl = r.el.querySelector('.acx__kleurhint');
        if (hintEl) {
          if (comboTotaal > 0 && comboTotaal < MINKLEUR) {
            hintEl.hidden = false;
            hintEl.textContent = 'Deze kleurcombinatie (' + r.clip + ' \u00b7 ' + r.letter + ') telt nu ' + comboTotaal +
              ' van de ' + MINKLEUR + ' clips die we minimaal per kleur printen. Voeg er meer toe, of gebruik dezelfde kleuren als een andere regel.';
          } else {
            hintEl.hidden = true;
          }
        }
      });
      if (logoAantal) {
        sumEl.insertAdjacentHTML('beforeend',
          '<tr><td><strong>Logo-opmaak<\/strong><br><span class="acx__muted">' +
          (logoAantal > 1 ? logoAantal + ' verschillende logo\u2019s' : 'eenmalig per logo') +
          '<\/span><\/td><td>' + logoAantal + ' \u00d7 ' + money(LOGOPRIJS) +
          '<br><span class="acx__muted">' + money(logoKosten) + '<\/span><\/td><\/tr>');
      }
      emptyEl.hidden = state.rows.length > 0;

      var problems = [];
      if (!state.brands.length) problems.push('Kies eerst je accumerk.');
      else if (!state.accus.length) problems.push('Kies eerst je accu.');
      if (!state.material) problems.push('Kies een uitvoering.');
      state.rows.forEach(function (r, i) {
        if (state.accus.length > 1 && !r.accu) problems.push('Kies bij naam ' + (i + 1) + ' voor welke accu die is.');
        if (r.mode === 'initialen' && !r.text) problems.push('Vul de initialen in bij naam ' + (i + 1) + '.');
        if (r.mode === 'logo' && !r.logoUrl) problems.push('Upload het logo bij naam ' + (i + 1) + '.');
        if (r.mode === 'logo' && r.logoUrl && !r.rights) problems.push('Bevestig de rechten bij naam ' + (i + 1) + '.');
      });
      if (total < MIN) problems.push('Minimale afname is ' + MIN + ' clips. Nog ' + (MIN - total) + ' te gaan.');
      Object.keys(combos).forEach(function (key) {
        if (combos[key] > 0 && combos[key] < MINKLEUR) {
          var delen = key.split('|');
          problems.push('Kleurcombinatie ' + delen[0] + ' \u00b7 ' + delen[1] + ': minimaal ' + MINKLEUR + ' clips in deze kleuren, nu ' + combos[key] + '.');
        }
      });
      errEl.textContent = problems.length ? problems[0] : '';
      cta.disabled = problems.length > 0 || !tier;
    }

    /* ---- winkelwagen ---- */
    cta.addEventListener('click', function () {
      var total = totaalClips();
      var tier = tierFor(state.material, total);
      if (!tier || total < MIN || !state.accus.length) return;

      var items = state.rows.map(function (r) {
        var accu = state.accus.filter(function (a) { return accuSleutel(a) === r.accu; })[0] || state.accus[0];
        var props = {
          'Past op accu': accu.merk + ' ' + accu.serie + ' \u00b7 ' + accu.naam +
            (accu.types ? ' (' + accu.types + ')' : ''),
          'Clipmodel': accu.model,
          'Clipkleur': r.clip,
          'Kleur tekst of logo': r.letter
        };
        if (r.mode === 'logo') {
          props['Logo'] = r.logoUrl;
          props['Logobestand'] = r.logoName;
          props['Rechten bevestigd'] = 'Ja';
        } else {
          props['Initialen'] = r.text;
        }
        return { id: tier.id, quantity: r.qty, properties: props };
      }).reverse();

      var logoAantal = logoSleutels().length;
      if (CFG.logoVariantId && logoAantal > 0) {
        items.push({
          id: CFG.logoVariantId,
          quantity: logoAantal,
          properties: { 'Hoort bij': 'Logo op accuclips', 'Aantal unieke logo\u2019s': String(logoAantal) }
        });
      }

      cta.disabled = true;
      cta.textContent = 'Bezig\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
        .then(function (out) {
          if (!out.ok) throw new Error(out.d.description || 'Toevoegen mislukt.');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          errEl.textContent = err.message + ' Probeer het opnieuw.';
          cta.disabled = false;
          cta.textContent = 'In winkelwagen';
        });
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-acx]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
